<template>
  <div class="table-content-container">
    <div class="table-top-bg"></div>
    <div class="table-area">
      <div class="wrapper">
        <div class="table">
          <div class="th" id="fixedThead">
            <div
              class="tr size-controller"
              :class="sticky.isFixed ? 'is-fixed-thead' : ''"
            >
              <div class="td">
                <div class="cell">
                  {{ $t("message.common.shippingCompany") }}
                </div>
              </div>
              <div class="td">
                <div class="cell">
                  {{ $t("message.common.qishigangwanzheng") }}
                </div>
              </div>
              <div class="td">
                <div class="cell"></div>
              </div>
              <div class="td">
                <div class="cell">
                  {{ $t("message.common.mudigangwanzheng") }}
                </div>
              </div>
              <div class="td">
                <div class="cell">
                  {{ $t("message.common.routeCode") }}
                </div>
              </div>
              <div class="td">
                <div class="cell">船名/航次</div>
              </div>
              <div class="td">
                <div class="cell"></div>
              </div>
              <div class="td">
                <div class="cell"></div>
              </div>
            </div>
          </div>
          <template>
            <div class="tb" v-if="layout.showTableBody">
              <SkeletonTableList :show="layout.showLoading"></SkeletonTableList>
              <div :style="{ opacity: list.length <= 0 ? '0' : '1' }">
                <transition-group name="list-complete" tag="div">
                  <div class="tr" v-for="item in list" :key="item.id">
                    <div class="tr-wrapper size-controller">
                      <div class="td td--ship">
                        <div class="cell">
                          <div class="ship-image">
                            <img
                              v-if="item.shippingUrl"
                              class="image"
                              :src="item.shippingUrl"
                            />
                            <img
                              v-else
                              class="image"
                              src="@/images/shippingLogo.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="td td--start-port">
                        <div class="cell">
                          <div class="wrp">
                            <div class="row-1">
                              <span class="date">{{
                                $str(stamp2StrMD(item.departureTime))
                              }}</span
                              ><span class="week" v-if="item.departureWeek">{{
                                $str(item.departureWeek, "", "(${})")
                              }}</span>
                            </div>
                            <div class="row-2" :title="item.polPortCd">
                              {{ item.polPortCd }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="td td--voyage">
                        <div class="cell">
                          <div class="wrp">
                            <div
                              class="top"
                              v-if="!$isInputEmpty(item.tripTime)"
                            >
                              <div class="text">
                                {{ item.tripTime }}
                                {{ $t("message.common.days") }}
                              </div>
                            </div>
                            <div class="point-line">
                              <div class="point"></div>
                              <div class="line"></div>
                              <div class="point"></div>
                            </div>
                            <div class="bottom">
                              <div class="text" v-if="item.travelWay == '直航'">
                                {{ $t("message.common.dir") }}
                              </div>
                              <div class="text" v-else>
                                {{ $t("message.common.via") }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="td td--end-port">
                        <div class="cell">
                          <div class="wrp">
                            <div class="row-1">
                              <span class="date">{{
                                $str(stamp2StrMD(item.arrivalTime))
                              }}</span
                              ><span class="week" v-if="item.arrivalWeek">
                                {{ $str(item.arrivalWeek, "", "(${})") }}</span
                              >
                            </div>
                            <div class="row-2" :title="item.podPortCd">
                              {{ item.podPortCd }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="td td--text">
                        <div class="cell" :title="item.lineCode">
                          {{ item.lineCode }}
                        </div>
                      </div>
                      <div class="td td--vessel">
                        <div class="cell">
                          <div class="wrp">
                            <div
                              class="row-1"
                              v-if="item.shipName"
                              :title="item.shipName"
                            >
                              {{ item.shipName }}
                            </div>
                            <div
                              class="row-2"
                              v-if="item.voyage"
                              :title="item.voyage"
                            >
                              {{ item.voyage }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="td td--price">
                        <div class="cell">
                          <div class="wrp">
                            <div class="row-1">
                              <div class="type">
                                {{ item.convert.containerType }}
                              </div>
                              <div
                                class="status status--green"
                                v-if="item.convert.hasPosition === '1'"
                              >
                                {{ $t("message.spotyunjia.xiancang") }}
                              </div>
                              <div
                                class="status status--red"
                                v-else-if="item.convert.hasPosition === '0'"
                              >
                                {{ $t("message.spotyunjia.shouqing") }}
                              </div>
                              <div class="status status--gray" v-else>为空</div>
                              <div
                                class="price"
                                v-if="!$isInputEmpty(item.convert.price)"
                                :title="$str(item.convert.price, '', '$${}')"
                              >
                                <div class="unit">$</div>
                                <div class="value-text">
                                  {{ item.convert.price }}
                                </div>
                              </div>
                            </div>
                            <div class="row-2">
                              更新:{{ $str(item.refreshTime, "-") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="td td--operator">
                        <div class="cell">
                          <TableRowDetailBtn
                            :isCollapseBtn="false"
                            :isExpanded="false"
                            @detail-click="$emit('detail-tap', item)"
                          ></TableRowDetailBtn>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </div>
            </div>
            <div class="tb--empty" v-if="layout.showTableEmpty">
              <EmptyPanel></EmptyPanel>
            </div>
          </template>
        </div>
      </div>
      <water></water>
    </div>
  </div>
</template>

<script>
import TableRowDetailBtn from "@/components/common/TableRowDetailBtn/index.vue";
import EmptyPanel from "../EmptyPanel.vue";
import SkeletonTableList from "../SkeletonTableList.vue";
import { DateTime } from "@/utils/DateTime";
export default {
  props: {
    sticky: {
      type: Object,
      default: () => ({}),
    },

    layout: {
      type: Object,
      default: () => ({}),
    },
    chooseForm: {
      type: Object,
      default: () => ({}),
    },

    list: {
      type: Array,
      default: () => [],
    },
  },
  components: { SkeletonTableList, EmptyPanel, TableRowDetailBtn },
  data() {
    return {
      // keyMap: {
      //   "20GP": {
      //     sKey: "havePosition20GP",
      //     pKey: "price20GP",
      //   },
      //   "40GP": {
      //     sKey: "havePosition40GP",
      //     pKey: "price40GP",
      //   },
      //   "40HQ": {
      //     sKey: "havePosition40HQ",
      //     pKey: "price40HQ",
      //   },
      // },
    };
  },
  created() {},
  computed: {},

  mounted() {},
  methods: {
    // getPrice(item) {
    //   return item[this.keyMap[this.chooseForm.containerType].pKey];
    // },
    // getHasPosition(item) {
    //   return item[this.keyMap[this.chooseForm.containerType].sKey];
    // },
    stamp2StrMD(stamp) {
      if (!stamp) return "";
      return DateTime.formatToStr(new Date(DateTime.getStamp(stamp)), "MM.DD");
    },
  },
};
</script>

<style scoped lang="scss">
.table-content-container {
  @mixin bottom-border {
    border-radius: 0 0 12px 12px;
  }
  .table-top-bg {
    background-color: #e7eef6;
    width: 1200px;
    margin: auto;
    height: 12px;
  }
  .table-area {
    min-height: calc(100vh - var(--navbar-height) - 140px - 178px);
    width: 1200px;
    margin: auto;
    margin-top: -12px;
    position: relative;
    .wrapper {
      width: 100%;
      .table {
        width: 100%;
        $thHeight: 44px;
        $tbHeight: 85px;
        margin-bottom: 0;
        .th {
          width: 100%;
          height: $thHeight;
          background-color: #fff;
          .tr {
            background: #ffffff;
            width: 100%;
            height: 100%;
            border-bottom: 1px solid #eef1f6;

            .td {
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              .cell {
                width: 100%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                font-size: 14px;
                font-weight: bold;
                color: #353744;
              }
            }
          }
          .is-fixed-thead {
            position: fixed;
            top: var(--navbar-bottom-height);
            height: $thHeight + 4px;
            width: 1200px;
            z-index: 900;
            border-top: 4px solid #f8f9fd;
            box-sizing: border-box;
          }
        }
        .tb {
          width: 100%;
          z-index: 1;
          position: relative;
          border-radius: 12px;
          background-color: #fff;
          .tr {
            width: 100%;
            border-bottom: 1px solid #f0f1f4;
            position: relative;
            transition: all 0.35s;
            &:nth-last-child(1) {
              border-bottom: 0px solid #f0f1f4;
              padding-bottom: 10px;
              // height: $tbHeight+10px;
              background-color: #fff;
              border-bottom-right-radius: 12px;
              border-bottom-left-radius: 12px;
              .tr-wrapper {
                @include bottom-border();
              }
            }
            .tr-wrapper {
              position: relative;
              transition: all 0.35s;
              width: 100%;
              background-color: #fff;
              height: $tbHeight;
              .td {
                height: 100%;
                display: flex;
                align-items: center;
                .cell {
                  width: 100%;
                  // height: 100%;
                }
              }
            }
            &:hover {
              box-shadow: 0px 4px 16px 0px rgba(2, 9, 29, 0.1);
              z-index: 1;
            }
          }
        }

        .size-controller {
          width: 100%;
          display: grid;
          grid-template-columns:
            123/1200 * 100%
            104/1200 * 100%
            127/1200 * 100%
            220/1200 * 100%
            120/1200 * 100%
            161/1200 * 100%
            260/1200 * 100%
            1fr;
          .td {
            &:first-child {
              padding-left: 10px;
            }
            &:last-child {
              padding-right: 10px;
            }
          }
        }
        .tb {
          // 定制
          .td {
            &.td--ship {
              .cell {
                .ship-image {
                  width: 36px;
                  height: 36px;
                  .image {
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                }
              }
            }
            &.td--start-port,
            &.td--end-port {
              .cell {
                max-width: 100%;
                .wrp {
                  max-width: 100%;
                  overflow: hidden;
                  .row-1 {
                    font-weight: bold;
                    color: #353744;
                    .date {
                      font-size: 16px;
                    }
                    .week {
                      font-size: 14px;
                    }
                  }
                  .row-2 {
                    margin-top: 4px;
                    max-width: 100%;
                    overflow: hidden;
                    font-size: 12px;
                    font-weight: 500;
                    color: #646778;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                  }
                }
              }
            }
            &.td--voyage {
              .cell {
                padding-right: 20px;
                width: 100%;
                //   height: 100%;
                .wrp {
                  width: 100%;
                  text-align: center;
                  position: relative;
                  // height: 100%;
                  display: flex;
                  align-items: center;
                  .top,
                  .bottom {
                    overflow: hidden;
                    position: absolute;
                    width: 100%;
                    text-align: center;
                    .text {
                      font-size: 12px;
                      font-weight: 500;
                      color: #5a5d71;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      text-align: center;
                    }
                  }
                  .point-line {
                    align-items: center;
                    display: flex;
                    align-items: center;
                    .point {
                      flex: 0 0 auto;
                      width: 10px;
                      height: 10px;
                      border: 2px solid #dfe2ec;
                      border-radius: 50%;
                    }
                    .line {
                      flex: 1 1 auto;
                      width: 87px;
                      height: 2px;
                      background: #dfe2ec;
                    }
                  }
                  .top {
                    top: -1.06em;
                  }
                  .bottom {
                    bottom: -1.06em;
                  }
                }
              }
            }
            &.td--end-port {
              .cell {
                .wrp {
                  .row-1 {
                  }
                  .row-2 {
                  }
                }
              }
            }
            &.td--text {
              width: 100%;
              overflow: hidden;
              .cell {
                padding-right: 10px;
                max-width: 100%;
                font-size: 14px;
                font-weight: 500;
                color: #444755;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }

            &.td--vessel {
              .cell {
                max-width: 100%;
                .wrp {
                  max-width: 100%;
                  overflow: hidden;
                  .row-1 {
                    font-size: 14px;
                    font-weight: 500;
                    color: #444755;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                  }
                  .row-2 {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    margin-top: 6px;
                    font-size: 12px;
                    font-weight: 500;
                    color: #444755;
                  }
                }
              }
            }
            &.td--price {
              .cell {
                width: 100%;
                .wrp {
                  max-width: 100%;
                  .row-1 {
                    max-width: 100%;
                    overflow: hidden;
                    display: flex;
                    align-items: baseline;
                    justify-content: flex-end;

                    .type {
                      flex: 0 0 auto;
                      font-size: 12px;
                      font-weight: bold;
                      color: #353744;
                    }
                    .status {
                      flex: 0 0 auto;
                      margin-left: 4px;
                      font-size: 12px;
                      font-weight: bold;
                      &.status--green {
                        color: #00b97a;
                      }
                      &.status--red {
                        color: #ff1949;
                      }
                      &.status--gray {
                        color: #606579;
                      }
                    }
                    .price {
                      flex: 0 1 auto;
                      margin-left: 8px;
                      font-weight: bold;
                      color: #ff5533;
                      display: flex;
                      align-items: baseline;
                      overflow: hidden;

                      .unit {
                        flex: 0 0 auto;
                        font-size: 12px;
                      }
                      .value-text {
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        font-size: 16px;
                      }
                    }
                  }
                  .row-2 {
                    margin-top: 3px;
                    font-size: 12px;
                    font-weight: 500;
                    color: #656977;
                    display: flex;
                    justify-content: flex-end;
                  }
                }
              }
            }
            &.td--operator {
              .cell {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                /deep/ .el-button {
                  padding: 0px;
                  width: 48px;
                  height: 18px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 9px;
                  span {
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.list-complete-move {
  transition: all 1s !important;
  // display: inline-block;
  // margin-right: 10px;
}
.list-complete-item {
  // transition: all 1.5s;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
